import CheckBox from "@material-ui/icons/CheckBox";
import React from "react";
import Fade from "react-reveal/Fade";
import { Redirect } from "react-router-dom";
import FetchData from "../../shared/fetchData";
import { checkValidity, updateObject } from "../../shared/utility";
import Alert from "../UI/Alert/Alert";
import Button from "../UI/Button/Button";
import ContentForm from "../UI/ContentForm/ContentForm";
import DatePicker from "../UI/DatePicker/DatePicker";
import Input from "../UI/Input/Input";
import Select from "../UI/Select/Select";
import IntervalTimePicker, {
  isEmptyTime,
} from "../UI/IntervalTimePicker/IntervalTimePicker";
import KioskMap from "./KioskMap/KioskMap";
import "./RentOrderForm.css";
const RentOrderForm = (props) => {
  const [latitude, setLatitude] = React.useState(35.7575);
  const [longitude, setLongitude] = React.useState(51.4099);
  const [zoom, setZoom] = React.useState(12);
  const [kioskDetails, setKioskDetails] = React.useState([]);
  const [locker, setLocker] = React.useState("");
  const [kioskId, setKioskId] = React.useState("");
  const [showFormDetails, setShowFormDetails] = React.useState(false);
  const [invalidDate, setInvalidDate] = React.useState(false);
  const [invalidSelect, setInvalidSelect] = React.useState(false);
  const [invalidTime, setInvalidTime] = React.useState(false);
  const [changeForm, setChangeForm] = React.useState(false);
  const [insertedOrder, setInsertedOrder] = React.useState(false);
  const [confirmedOrder, setConfirmedOrder] = React.useState(false);
  const [showOrders, setShowOrders] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false);
  const [rent, setRent] = React.useState("");
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [alertMessage, setAlertMessage] = React.useState("");
  const [startTime, setStartTime] = React.useState("");
  const [endTime, setEndTime] = React.useState("");
  const [timeFocus, setTimeFocus] = React.useState({ start: 0, end: 0 });
  const [proviances, setProviances] = React.useState([]);
  const [geoNames, setGeoNames] = React.useState([]);
  const [proviance, setProviance] = React.useState("");
  const [geoName, setGeoName] = React.useState("");
  const [kiosk, setKiosk] = React.useState("");
  const [orderAmount, setOrderAmount] = React.useState({
    amount: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "هزینه اجاره",
        unit: "ریال",
      },
      validation: {
        required: true,
      },
      errorMessage: "",
      valid: true,
      value: "",
    },
  });
  const [rentInfo, setRentInfo] = React.useState({
    lockerSerials: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "شماره سریال ها",
      },
      validation: {
        required: true,
      },
      errorMessage: "الزامی است",
      valid: true,
      value: "",
    },
  });

  React.useEffect(() => {
    var info = {
      geoName: {
        type: "PRV",
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/geonames/getGeoNames";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setProviances(result.geoNames);
      })
      .catch((error) => console.log(error));
    var info = {
      isActive: "1",
      isAlive: "1",
      finalized: "1",
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/kiosks/getAllKiosksWithDetails";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setKioskDetails(result.kiosks);
      })
      .catch((error) => console.log("error", error));
    var raw = JSON.stringify({
      locker: {},
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    });
  }, []);

  const inputChangedHandler = (event, controlName) => {
    let val =
      controlName == "amount"
        ? event.target.value.toString().replace(/[^0-9]/g, "")
        : event.target.value;
    let value =
      controlName == "amount"
        ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : val;
    const updatedControls = updateObject(orderAmount, {
      [controlName]: updateObject(orderAmount[controlName], {
        value: value,
        valid: checkValidity(
          event.target.value,
          orderAmount[controlName].validation
        ),
      }),
    });
    setOrderAmount(updatedControls);
  };

  const inputChangedHandlerRentInfo = (event, controlName) => {
    const updatedControls = updateObject(rentInfo, {
      [controlName]: updateObject(rentInfo[controlName], {
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          rentInfo[controlName].validation
        ),
      }),
    });
    setRentInfo(updatedControls);
  };

  const changeMapHandler = (event) => {
    let lat = event.target.getCenter().lat;
    let lng = event.target.getCenter().lng;
    let zoom = event.target.getZoom();
    setLatitude(lat);
    setLongitude(lng);
    setZoom(zoom);
  };
  const changeLocation = (lat, lng) => {
    setLatitude(lat);
    setLongitude(lng);
  };

  const toggleShowOrderDetail = (event, value) => {
    setShowFormDetails(value);
  };

  const changeStartDate = (unix, formatted) => {
    setStartDate(formatted);
    setTimeFocus((prev) => ({ ...prev, start: prev.start + 1 }));
  };

  const changeEndDate = (unix, formatted) => {
    setEndDate(formatted);
    setTimeFocus((prev) => ({ ...prev, end: prev.end + 1 }));
  };

  const changeLocker = (selectedOption) => {
    setLocker(selectedOption);
  };

  const insertOrder = (event) => {
    setShowAlert(false);
    let valid = true;
    let info = rentInfo;
    for (let key in info) {
      if (info[key].value === "") {
        info[key].valid = false;
        setRentInfo(info);
      }
    }
    if (isEmptyTime(startTime)) {
      valid = false;
      setInvalidTime(true);
    }
    if (isEmptyTime(endTime)) {
      valid = false;
      setInvalidTime(true);
    }
    if (startDate == null || startDate == "") {
      valid = false;
      setInvalidDate(true);
    }
    if (endDate == null || endDate == "") {
      valid = false;
      setInvalidDate(true);
    }
    if (kioskId == null || kioskId == "") {
      valid = false;
    }
    if (!valid) {
      if (changeForm) {
        setChangeForm(false);
      } else {
        setChangeForm(true);
      }
    } else {
      var raw = JSON.stringify({
        kioskId: kioskId,
        startDate: startDate,
        lockerSerials: rentInfo.lockerSerials.value,
        startTime: startTime,
        endDate: endDate,
        endTime: endTime,
        version: "mtpx001",
      });

      var url = "management/api/v1/rents/insertRent";
      FetchData(raw, url)
        .then((response) => response.json())
        .then((result) => {
          if (result.status == 0) {
            setInsertedOrder(true);
            setRent(result.rent);
          } else if (result.message == "LOCKER_IS_FULL") {
            setShowAlert(true);
            setAlertMessage("باکس در این بازه زمانی پر است");
          } else if (result.message == "INVALID_SHIFT") {
            setShowAlert(true);
            setAlertMessage("شیفت وجود ندارد");
          } else if (result.message == "INVALID_DATE") {
            setShowAlert(true);
            setAlertMessage("زمان انتخاب شده صحیح نیست");
          } else {
            setShowAlert(true);
            setAlertMessage("اطلاعات وارد شده صحیح نیست");
          }
        })
        .catch((error) => console.log("error", error));
    }
  };

  const confirmRent = (event) => {
    setShowAlert(false);
    var raw = JSON.stringify({
      rentNumber: rent != null && rent != "" ? rent.rentNumber : "",
      amount:
        orderAmount.amount.value != null && orderAmount.amount.value != ""
          ? orderAmount.amount.value.toString().replace(/[^0-9]/g, "")
          : "",
      payType: "CREDIT",
      version: "mtpx001",
    });

    var url = "management/api/v1/rents/confirmRent";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          setConfirmedOrder(true);
        } else if (result.message == "INSUFFICIENT_CREDIT") {
          setShowAlert(true);
          setAlertMessage("اعتبار کافی نیست");
        }
      })
      .catch((error) => console.log("error", error));
  };

  const putLocker = (event, id) => {
    setKioskId(id);
  };

  const toggleShowResult = (event, value) => {
    setInsertedOrder(value);
  };

  const ordersPanel = (event) => {
    setShowOrders(true);
  };

  const changeStartTime = (value) => {
    setStartTime(value);
  };

  const changeEndTime = (value) => {
    setEndTime(value);
  };
  const provianceChange = (value) => {
    setProviance(value);
    var info = {
      geoName: {
        type: "CTY",
        parentId: value?.value,
      },
      pl: 1000,
      pn: 1,
      version: "mtpx001",
    };
    var raw = JSON.stringify(info);
    var url = "management/api/v1/geonames/getGeoNames";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setGeoNames(result.geoNames);
      })
      .catch((error) => console.log(error));
  };
  const geoNameChange = (value) => {
    setLatitude(parseFloat(value.lat));
    setLongitude(parseFloat(value.lon));
    setGeoName(value);
  };
  let provianceList = [];
  if (proviances != null && proviances.length != 0) {
    let prvns = [...proviances];
    prvns.map((b) => {
      provianceList.push({
        value: b.id,
        label: b.description,
      });
    });
  }
  let geoNameList = [];
  if (geoNames != null && geoNames.length != 0) {
    let gnms = [...geoNames];
    gnms.map((b) => {
      geoNameList.push({
        value: b.id,
        lat: b.lat,
        lon: b.lon,
        label: b.description,
      });
    });
  }
  const formElementsArray = [];
  for (let key in orderAmount) {
    formElementsArray.push({
      id: key,
      config: orderAmount[key],
    });
  }
  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        col="6 mt-3"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });
  const formElementsArrayBoxes = [];
  for (let key in rentInfo) {
    formElementsArrayBoxes.push({
      id: key,
      config: rentInfo[key],
    });
  }
  let formBoxes = formElementsArrayBoxes.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        col="6 mt-3"
        changed={(event) => inputChangedHandlerRentInfo(event, formElement.id)}
      />
    );
  });
  const orders = showOrders ? <Redirect to="my-orders" /> : "";
  return (
    <div>
      {orders}
      {!insertedOrder && !showFormDetails ? (
        <Fade duration={200} left cascade>
          <div>
            <div className="row justify-content-center w-100 ml-0 mr-0">
              <Select
                name="form-field-name"
                value={proviance}
                placeholder="استان"
                options={provianceList}
                className="map-geo"
                onChange={provianceChange}
                col="4 mt-3"
              />
              <Select
                name="form-field-name"
                value={geoName}
                placeholder="شهر"
                className="map-geo"
                options={geoNameList}
                onChange={geoNameChange}
                col="4 mt-3"
              />
            </div>
            <KioskMap
              lat={latitude}
              lng={longitude}
              kiosks={kioskDetails}
              kiosk={kiosk}
              changeLocationOnKiosk={(value) => {
                setZoom(22);
                setLatitude(value.lat);
                setLongitude(value.lon);
                setKiosk(value);
              }}
              zoom={zoom}
              latLngChangeHandler={changeMapHandler}
              changeLocation={changeLocation}
              toggleShowOrderDetail={toggleShowOrderDetail}
              putLocker={putLocker}
            />
          </div>
        </Fade>
      ) : (
        <div>
          {!insertedOrder && !confirmedOrder ? (
            <div className="row justify-content-center">
              <div className="rent-ord-cntnr">
                <ContentForm headetText="اطلاعات سفارش">
                  <div className="order-form-datetime-block">
                    <div className="order-form-datetime-title">بازه رزرو سفارش</div>
                    <div className="row m-0 w-100">
                      <DatePicker
                        className={
                          invalidDate && (startDate == null || startDate == "")
                            ? "invalid-date"
                            : ""
                        }
                        change={changeStartDate}
                        value={startDate}
                        placeHolder="تاریخ شروع"
                        col="6"
                      />
                      <IntervalTimePicker
                        onChange={changeStartTime}
                        value={startTime}
                        placeHolder="ساعت شروع"
                        focusTrigger={timeFocus.start}
                        className={
                          invalidTime && isEmptyTime(startTime)
                            ? "invalid-time"
                            : ""
                        }
                        col="6"
                      />
                      <DatePicker
                        className={
                          invalidDate && (endDate == null || endDate == "")
                            ? "invalid-date"
                            : ""
                        }
                        change={changeEndDate}
                        value={endDate}
                        placeHolder="تاریخ پایان"
                        col="6"
                      />
                      <IntervalTimePicker
                        onChange={changeEndTime}
                        value={endTime}
                        placeHolder="ساعت پایان"
                        focusTrigger={timeFocus.end}
                        className={
                          invalidTime && isEmptyTime(endTime)
                            ? "invalid-time"
                            : ""
                        }
                        col="6"
                      />
                    </div>
                  </div>
                  {formBoxes}
                  <div className="row justify-content-center w-100 mt-3">
                    <div className="col-6 text-center">
                      <Button
                        btnType="General"
                        clicked={(event) => toggleShowOrderDetail(event, false)}
                      >
                        برگشت
                      </Button>
                    </div>
                    <div className="col-6 text-center">
                      <Button btnType="Success" clicked={insertOrder}>
                        ثبت
                      </Button>
                    </div>
                  </div>
                </ContentForm>
              </div>
            </div>
          ) : (
            <div>
              {insertedOrder && !confirmedOrder ? (
                <div className="row justify-content-center">
                  <div className="clndr-zn-cntnr">
                    <ContentForm headetText="اطلاعات سفارش">
                      <div className="row justify-content-center w-100">
                        {form}
                      </div>
                      <div className="row justify-content-center w-100 mt-3">
                        <div className="col-6 text-center">
                          <Button btnType="Success" clicked={confirmRent}>
                            ثبت
                          </Button>
                        </div>
                      </div>
                    </ContentForm>
                  </div>
                </div>
              ) : (
                <div>
                  {confirmedOrder ? (
                    <div className="row justify-content-center">
                      <div className="confirm-ord-form">
                        <div className="row justify-content-center w-100 mt-3">
                          <div className="col-4 text-left">
                            <CheckBox className="cnfrm-ord-icon" />
                          </div>
                          <div className="col-8 text-right pt-2 pb-3">
                            سفارش شما با موفقیت ثبت شد.
                          </div>
                        </div>
                        <div className="ord-form-number">
                          کد رهگیری: {rent.rentNumber}
                        </div>
                      </div>
                      <div className="row justify-content-center w-100 mt-3">
                        <div className="col-6 text-center">
                          <Button btnType="Success" clicked={ordersPanel}>
                            لیست سفارشات
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {showAlert == true ? (
        <div class="row justify-content-center mt-5">
          <div>
            <Alert variant="error" class="mt-3" text={alertMessage} />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default RentOrderForm;
